export default {
  props: {
    blast: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      responses: this.blast.responses,
      reviews: this.blast.reviews,
    }
  },
  computed: {
    noReviewsAvailableMessage () {
      return (this.blast.reviewsGivenCount >= this.blast.assignment.maxReview) ? "You have completed all assigned reviews!" : "There are currently no peer responses available to review. Please check back later!"
    },
    reviewCountMessage () {
      switch(this.blast.reviewsGivenCount) {
        case 0:
          return "not completed any reviews"
        case 1:
          return "completed one review"
        default:
          return `completed ${this.blast.reviewsGivenCount} reviews`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BlastStudent/mixin.js